module.exports = __webpack_public_path__ + "static/media/play.301212df.svg";